import { reduce, includes, map, prop } from 'ramda';

export default errors => {
  const fieldNamesWithErrors = map(prop('field'), errors);
  return reduce(
    (acc, { name }) => acc || includes(name, fieldNamesWithErrors),
    false
  );
};
